var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var Offer = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ width: "34", height: "37" }, props),
        React.createElement("g", null,
            React.createElement("path", { fill: "#00C1B1", opacity: ".4", d: "M27.785 19.713L16.77 25.332 6.049 19.745V3.863h22.23z" }),
            React.createElement("path", { fill: color, d: "M31.513 16.374l-2.682-2.595V18l2.682-1.625zm.461 1.458l-10.69 6.481 10.69 9.875V17.832zM19.96 25.116l-3.223 1.954-3.102-1.88L2.67 35.15h28.154L19.959 25.117zm-7.651-.73l-10.81-6.554v16.373l10.81-9.82zM1.959 16.374L4.641 18v-4.221L1.96 16.374zm4.18 2.534l10.597 6.423 10.597-6.423V5.144H6.139v13.764zm22.692-7.201l4.64 4.49v20.435H0V16.197l4.64-4.491V3.662h8.311L16.736 0l3.783 3.662h8.312v8.045zM18.377 3.662l-1.641-1.588-1.642 1.588h3.283zM8.385 9.588V8.107h8.351v1.481h-8.35zm0 2.965V11.07h16.699v1.483H8.385zm0 2.963v-1.481h16.699v1.481H8.385zm0 2.962v-1.482h16.699v1.482H8.385zm4.998 2.963V19.96h6.704v1.481h-6.704z" }))));
};
Offer.defaultProps = {
    color: '#111',
};
export default Offer;
//# sourceMappingURL=Offer.js.map